var React = require('react');

function Year (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M28 6C28 5.46957 27.7893 4.96086 27.4142 4.58579C27.0391 4.21071 26.5304 4 26 4H22V2H20V4H12V2H10V4H6C5.46957 4 4.96086 4.21071 4.58579 4.58579C4.21071 4.96086 4 5.46957 4 6V26C4 26.5304 4.21071 27.0391 4.58579 27.4142C4.96086 27.7893 5.46957 28 6 28H10V26H6V6H10V8H12V6H20V8H22V6H26V10H28V6Z","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"21","cy":"21","r":"8","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M21 16L21 21L26 21","stroke":"currentColor","strokeWidth":"2","key":2})]);
}

Year.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Year;

Year.default = Year;
